import { Subject } from 'rxjs'
import { SHOW_LOADING, HIDE_LOADING } from '../constants/app.constant'

// import { of } from 'rxjs'
const loadingSubject = new Subject()
export const loading = {
  show: () =>
    loadingSubject.next({
      type: SHOW_LOADING,
      payload: undefined,
      meta: null,
    }),
  hide: () =>
    loadingSubject.next({
      type: HIDE_LOADING,
      payload: undefined,
      meta: null,
    }),
}
const loadingEpic$ = () => loadingSubject.asObservable()
export default [loadingEpic$]



// WEBPACK FOOTER //
// ./src/epics/app.epic.ts